export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "Няма записи",
    "notifications.rp_has_been_updated": "Проектът в полза на общността е актуализиран",
    "moduleTitle.files": "Файлове",
    "label.coordinator": "Координатор",
    "sidebar.translations_managment": "",
    "table.file": "Файл",
    "label.report_overview": "",
    "label.parent_agreement": "Родителско&#39;s съгласие",
    "parentalConsent.i_consent_to_and_understand_that": "6. съм информиран/а и давам съгласието си синът ми/ дъщеря ми да бъдат\nфотографирани по време на участието му/и в активности, свързани с Наградата и тези фотографии да бъдат използвани с рекламна цел, след писмено съгласие от страна на участника и неговия родител/настойник.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. информиран/а съм, че участниците са задължени да спазват задълженията на Наградата, описани в Дневника или Онлайн Дневника, философията и поведенческите стандарти на съответния Оператор на Наградата (които могат да бъдат променяни периодично) и изискванията на Организацията/Оператор на Наградата, отнасящи се до плана за извънредни ситуации, оценяването на активностите и провеждането на Приключенското пътуване. Разбирам, че Организацията/Оператор на Наградата има\nправото да прекрати участието на участника, ако той/тя не ги спазва.",
    "table.end_date": "Крайна дата",
    "label.activation_date": "Дата на активиране",
    "label.report": "",
    "label.award_is_offline": "Наградата е офлайн",
    "label.pending_changes": "Изчакване на промени...",
    "errors.min_nights_required": "Изискват се минимум {nights} нощ(и)",
    "label.country": "Държава",
    "notifications.award_leader_has_been_returned": "Регистрацията на лидер е върната за редакция",
    "notifications.participant_has_been_updated": "Регистрацията на участника е актуализирана",
    "label.phone_number": "Телефонен номер",
    "roles.aj_assessor": "Оценител на Приключеснко пътуване",
    "notifications.person_state_has_been_changed": "Статуса беше променен",
    "pageTitle.dashboard": "Табло за управление",
    "moduleTitle.global_payment_method": "Глобален метод за плащане",
    "label.organization_type": "Вид на организацията",
    "button.account_settings": "Настройки на профила",
    "notifications.contact_has_been_updated": "Контактът е актуализиран",
    "participant.recover_password": "Възстанови паролата",
    "notifications.assessment_request_has_been_sent": "Запитването за оценка е изпратено",
    "button.unassign": "",
    "label.start_date": "Начална дата",
    "label.assign_labels": "",
    "sidebar.participants": "Участници",
    "roles.coordinator": "Координатор",
    "label.organization_contact": "Контакт на организацията",
    "tabs.customization": "Персонализация",
    "sidebar.award_units": "Организации",
    "button.change_goal": "Промени цел",
    "translationsManagement.selectProject": "Избор на проект",
    "award.rp": "Проект в полза на общността",
    "label.size": "Размер",
    "label.bulk_action_results": "Резултат от груповото действие",
    "notifications.activity_has_been_approved": "Дейността е одобрена",
    "label.payment_type": "Начин на плащане",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "Изпрати отново запитване за оценка",
    "notifications.template_has_been_removed": "Шаблонът е изтрит",
    "button.award_settings": "Настройки на Наградата",
    "pageTitle.payment": "Плащане",
    "tasks.return_award": "Редактирай Наградата",
    "label.link": "линк",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "Моят регионален офис - Контакти",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "Одобрение на направление",
    "table.logs": "Записи",
    "moduleTitle.remove_file": "Изтрий файла",
    "label.email_confirmed": "Имейлът е потвърден",
    "notifications.activity_has_been_returned": "Дейността е върната за редакция",
    "label.note": "Бележка",
    "button.show": "",
    "tabs.adventurous_journey": "Приключенско пътуване",
    "sidebar.my_todolist": "Моят списък със задачи",
    "label.here": "тук",
    "organisation.change_award_mode": "Промени режима на Наградата",
    "table.note_from_al": "Бележки от Лидера",
    "label.gender": "Пол",
    "moduleTitle.remove": "Изтрий?",
    "errors.must_be_less_than": "Трябва да е по-малко от {limit}",
    "button.logout": "Изход",
    "label.no_selected_participants": "Няма избрани участници",
    "button.new_aj_event": "Ново събитие за приключенско пътуване",
    "label.employement_status": "Заетост",
    "tabs.logs": "Записи",
    "tabs.contacts": "Контакти",
    "label.option": "Опция",
    "dashboard.charts": "Графики",
    "notifications.rp_has_been_approved": "Проектът в полза на общността е одобрен",
    "pageTitle.new_participant": "Нов участник",
    "notifications.award_leader_has_been_approved": "Регистрацията на лидер е одобрена",
    "moduleTitle.would_you_like_to_remove_leader_training": "Искате ли да изтриете Обучението за Лидери?",
    "moduleTitle.update_configuration_value": "Актуализирай стойността на конфигурацията",
    "table.description": "Описание",
    "table.organization": "Организация",
    "label.youtube": "Youtube",
    "label.author": "Автор",
    "table.suitable_for_award_level": "Подходящо за ниво в Наградата",
    "label.content_update": "Моля изчакайте. Съдържанието се актуализира...",
    "notifications.new_question_has_been_added": "Добавен е нов въпрос",
    "pageTitle.nao_awards": "Национален офис - Награди",
    "table.last_name": "Фамилия",
    "moduleTitle.adventurous_journey_detail": "Детайли за приключението",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "Групово действие"},
    "label.project_location_type": "Местонахождение на проекта",
    "label.email_help_award_level": "Ниво в Наградата.",
    "label.date": "Дата",
    "label.previous_completed_award_place": "Къде",
    "button.show_more": "Покажи повече",
    "label.wwc_number": "WWC number",
    "button.filter": "Филтър",
    "notifications.rp_has_been_returned": "Проектът в полза на общността е върнат за редакция",
    "pageTitle.residetial_project_assessor_report": "Проект в полза на общността - доклад на ментора",
    "label.generating": "Генериране...",
    "moduleTitle.finance_system_data": "Данни за финансовата система",
    "notifications.adventurous_journey_state_has_been_changed": "Статуса на приключенското пътуване е променен",
    "route.levels": "Нива",
    "moduleTitle.activity_leader": "Лидер на дейността",
    "tasks.approve_event": "Одобри събитето",
    "tasks.reject_event": "Редактирай събитието",
    "table.region": "Регион",
    "pageTitle.nao_award_leaders": "Национален офис - Лидери",
    "errors.must_be_at_least": "Трябва да е поне {min} символа",
    "table.title": "Заглавие",
    "table.last_activity": "Последна активност",
    "tasks.delete_registration": "Изтрий регистрацията",
    "table.date_time": "Дата / час",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. Операторите на наградата са задължени да защитят личните Ви данни. Личната информация в тази декларация се събира с цел участие в Наградата. Участници, които не предоставят тази информация не могат да участват в Наградата. Личните Ви данни могат също да бъдат използвани, за да получите информация за други активности, свързани с наградата или събития, които смятаме, че ще представляват интерес за Вас. Възможно е да предоставим личните Ви данни на други местни или международни организации и доставчици на услуги, които ни подпомагат в администрирането на и работата по Наградата. Ако желаете да се свържете с нас или да получите достъп до личните Ви данни, моля обърнете се към съответния Оператор на Наградата. Свържете се с Оператора на Наградата и ако желаете да получите информация за обработването и съхранението на лични данни.",
    "aj.practice_journey": "Предварително Приключенско пътуване",
    "notification.log_has_been_restored": "Записът към дейността беше възстановен",
    "tabs.my_participants": "Моите участници",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "Супервайзор",
    "moduleTitle.your_parental_consent": "Твоето съгласие от родител",
    "route.registration_participants": "Регистрации на участници",
    "placeholder.start_typing": "Започни да пишеш...",
    "tasks.approve_award": "Одобри Наградата",
    "route.registrations": "Регистрации",
    "button.add_activity": "Добавяне на дейност",
    "notifications.aj_event_has_been_created": "Създадено е събитие за Приключенско пътуване",
    "states.supervisor_approval": "Одобрение на Ментор/Оценител",
    "label.description": "Описание",
    "button.leave_anyway": "Излез",
    "tabs.registrations": "Регистрации",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "Успешно зареждане на трансакциите",
    "pageTitle.nao_registration": "Национален офис - Регистрация",
    "pageTitle.mro_logs": "Моят регионален офис - Записи",
    "meta.page_not_found": "Страницата не е намерена",
    "label.bulk_action_unsuccessful": "{count} позиции неуспешно променени:",
    "global.days": "дни",
    "table.review": "Преглед",
    "table.as_assessor_for": "Като ментор за",
    "roles.if_staff_statistical_user": "Статистически потребител на МФ",
    "table.levels": "Нива",
    "label.suitable_for_level": "Подходящо за ниво",
    "pageTitle.leaders": "Лидери",
    "moduleTitle.send_test_email": "Изпрати тестов имейл",
    "pageTitle.tasks_removed_registration": "Изтрити регистрации на участници",
    "label.you_will_be_forced_to_login_again_after_change": "След промяната, ще бъде необходимо да влезете в профила си отново",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "Одобрение на направления",
    "pageTitle.payments": "Плащания",
    "global.nights": "нощи",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "Избери организация",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "Качи документи",
    "label.migrated_contact_email": "Имейл контактът е преместен",
    "label.for_award_unit": "За Лицензирания оператор",
    "label.aj_template_note": "Шаблон за бележка",
    "table.last_log_added": "Последен лог в дневника",
    "button.view_participant": "От участника",
    "label.please_comment_on_the_participants": "Моля, коментирайте представянето на участниците",
    "label.consent_already_given_login": "Формулярът за съгласие е получен. Моля, влезте в профила на детето си.",
    "participant.level_start_date": "{value} начална дата",
    "sidebar.my_region_office": "Моят регионален офис",
    "states.section_signoff": "Одобрение на направление",
    "moduleTitle.assessor_details": "Информация за ментора",
    "moduleTitle.adventurous_journey_settings": "Настройки на Приключенското пътуване",
    "moduleTitle.note_from_al": "Бележка към Лидера",
    "button.add_role": "Добави роля",
    "table.run": "Изпълни",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "Ръководство за потребители за приложение - Лидер",
    "tabs.section_approval": "Одобрение на направление",
    "roles.award_verifier": "Проверяващ",
    "tabs.activity_approval": "Одобрение на дейност",
    "logs.add_log": "Добави запис",
    "tabs.award": "Награда",
    "notifications.this_role_has_read_only_persmission": "Т",
    "table.no_filtered_results": "Няма филтрирани резултати",
    "button.praise": "Коментар",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "Информация за местонахождението",
    "label.optional": "(по избор)",
    "errors.do_not_match": "Не съвпадат",
    "label.use_comma_for_multiple_entries": "Използвайте запетайка за повече от един запис",
    "label.operating_authority": "Регионален координатор",
    "label.activity_section": "Направление",
    "notifications.you_have_been_logged_out": "Излязохте от профила си",
    "table.finished": "Завършено",
    "button.same_as_billing": "Същия като адреса за плащане",
    "table.payment": "Плащане",
    "table.current_level": "Текущо ниво",
    "button.view_nao": "Върнато от Националния офис на Наградата (с указания за ревизия)",
    "table.email_confirmation": "Потвърждение по имейл",
    "moduleTitle.shipping_address": "Адрес за доставка",
    "label.secondary_phone_type": "Вид на втория телефонен номер",
    "notifications.saved": "Запазено",
    "pageTitle.all_participants": "Всички участници",
    "label.first_name": "Първо име",
    "label.oa_price": "Цена",
    "table.award_mode": "Режим на Наградата",
    "tabs.api_keys": "API ключове",
    "award.award_detail": "Детайли за Наградата",
    "tabs.user_management": "Управление на потребителите",
    "tabs.all_events": "Всички събития",
    "notifications.history_record_has_been_removed": "Записът на историята е премахнат.",
    "award.no_data": "Няма данни",
    "notifications.preparation_training_has_been_added": "Подготовката и инструктажите са добавени",
    "label.message": "Съобщение",
    "notifications.participant_info_updated": "Информацията за участника беше актуализирана",
    "roles.nao_staff": "Служители на Националния оператор на Наградата",
    "tabs.adventurous_journeys": "Приключенски пътувания",
    "label.gops": "",
    "route.upload": "Добави",
    "notifications.history_record_has_been_added": "Записът на историята е добавен.",
    "notifications.history_record_has_been_updated": "Историческият запис е актуализиран",
    "label.no_data": "Няма данни",
    "button.add_coordinator": "Добави Координатор",
    "label.you_are_already_logged_as": "Вече сте влезли като ",
    "route.my_national_office": "Моят Национален офис",
    "tabs.leaders": "Лидери",
    "label.email_confirmation": "Потвърждение по имейл",
    "table.registration_date": "Дата на регистрация",
    "notifications.role_has_been_removed": "Ролята е изтрита",
    "button.move": "Премести",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "Детайли",
    "table.award_unit": "Организация",
    "sidebar.settings": "Настройки",
    "dashboard.leader_state": "Лидери - по регион",
    "notifications.award_unit_has_been_approved": "Регистрацията на лидера е одобрена",
    "states.awaiting_approval": "Изчакване на одобрение",
    "table.level": "Ниво",
    "table.action_requested": "Необходимо действие",
    "label.organisation_mode": "Режим на организацията",
    "label.no_note": "Няма бележки",
    "tabs.my_events": "Моите събития",
    "notifications.participants_have_been_added": "Добавени са участници",
    "tabs.registration_questions": "",
    "button.delete_registration": "Изтрий регистрацията",
    "notifications.parental_consent_link_has_been_sent": "Декларацията за родителско съгласие е изпратена",
    "moduleTitle.select_role_organization": "Избери роля и организация",
    "label.experience": "Опит",
    "translationsManagement.modal.title": "Желаете ли да актуализирате трансакциите?",
    "table.ic": "Независима държава",
    "table.id": "Код",
    "label.notify_email_explanation": "Участникът ще бъде уведомен чрез мейл, че неговата молба за доклад от ментора не е доставена успешно и ще бъде помолен да поправи мейл адреса и да поиска доклад отново.",
    "participant.would_you_like_to_remove": "Искате ли да изтриете този профил?",
    "table.fields_included": "",
    "label.user_guide_web_leader": "Наръчник за потребители - Лидер",
    "label.journey_type": "Вид на пътуването",
    "button.setup": "Настойване",
    "tabs.my_national_office": "Моят Национален Офис",
    "notifications.training_has_been_removed": "Обучението е изтрито",
    "label.nominated_and_identified_persons": "Номинирани хора, които могат да разглеждат информацията, но не и да я редактират",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Излязохте от профила си поради неактивност",
    "states.award_leader_signoff": "Одобрение от Лидер",
    "table.award_signoff_attempts": "Опити за одобрение на Наградата",
    "sidebar.regions": "Региони",
    "label.activity_deleted_note": "Дейността е изтрира. Можеш да я върнеш като кликнеш върху бутона по-долу.",
    "table.total": "Общо",
    "errors.a_problem_has_occured_during_processing": "При обработката възникна проблем, вижте повече информация",
    "participant.participant_already_has_gold_award": "Участникът вече е постигнал Златно ниво",
    "pageTitle.mro": "Моят регионален офис",
    "notifications.authorization_code_has_expired": "Кодът е с изтекъл срок",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "Събития за Приключенско пътуване",
    "global.loading": "Зареждане",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "Регистрации",
    "label.any_string": "Всяка поредица",
    "contact.change_contact_status": "Промени статуса на контакта",
    "tabs.registration": "Регистрация",
    "label.override_payment_note": "Замяна на бележката за плащане",
    "notifications.section_has_been_signed_off": "Направлението е одобрено",
    "label.payment_date": "Дата на плащане",
    "button.approve": "Одобри",
    "moduleTitle.loggin_in": "Вписване",
    "label.website": "Уебсайт",
    "label.role": "Роля",
    "table.assessor_report": "Доклад на оценителя",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "Предишен опит като Ментор/Оценител",
    "pageTitle.registrations": "Регистрации",
    "parentalConsent.this_form_must_be_completed": "Този формуляр  <strong>трябва</strong> да бъде попълен от родител / настойник за участници под <strong> 18 г./националната възраст на юридическа отговорност в страната, в която живеете</strong>.",
    "button.apply": "Приложа",
    "errors.include_at_least_one_number": "Включи поне една цифра",
    "label.content_restore": "Актуализиране на сесията...",
    "logs.hour": "час",
    "parentalConsent.i_have_read_and_understand": "7. Прочетох и разбрах различните нива и изисквания на Наградата, както е посочено в Описанието на Наградата.",
    "notifications.award_was_deleted": "",
    "label.journey_category": "Вид на пътуването",
    "notifications.search_cancelled": "Търсенето беше прекъснато, трябва да изчакате търсенето да приключи.",
    "route.detail": "Информация",
    "route.user_guide": "Ръководство за потребители",
    "moduleTitle.history": "История",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Участници без Лидер",
    "states.inactive": "Неактивен",
    "pageTitle.search_results": "Резултати от търсенето",
    "button.proceed_to_login": "Продължете към влизане в профила",
    "pageTitle.assessor_report_reject": "Докладът на Оценителя е върнат за редакция",
    "notifications.contact_has_been_removed": "Контактът е премахнат",
    "sidebar.operating_authorities": "Регионални координатори",
    "label.no_note_from_participant": "Липсва бележка от участника",
    "aj.preparation_and_training": "Подготовка и инструктажи",
    "route.user_guide_web_leader": "Наръчник за потребители - Лидер",
    "label.position_in_organization": "Позиция в организацията",
    "errors.emails_dont_match": "Имейлите не съвпадат",
    "route.my_participants": "Моите участници",
    "pageTitle.customisations": "Персонализации",
    "tabs.localization_files": "Локализиране на файлове",
    "table.assessor_approval": "Одобрение от Оценител",
    "tabs.related_contacts": "Свързани контакти",
    "table.aus": "Организации",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "Възможни стойности:",
    "label.if_your_download_doesnt_start": "Ако свалянето не започне автоматично, моля кликнете тук",
    "route.independent_award_centres": "Независими оператори на Наградата",
    "pageTitle.user_guide": "Ръководство за потребители",
    "button.visit": "",
    "label.hours_first_letter": "ч.",
    "pageTitle.my_organization_detail": "Моята организация - детайли",
    "pageTitle.nao_detail": "Национален офис - Информация",
    "button.change": "Промени",
    "award.aj": "Приключенско пътуване",
    "table.award_state": "Статус на Наградата",
    "pageTitle.tasks_award_signoff": "Одобрение на Награди",
    "pageTitle.regions": "Региони",
    "notifications.award_has_been_signed_off": "Наградата е одобрена",
    "dashboard.award_approved_by": "Одобрени награди - по ниво през 2016",
    "tabs.new_template": "Нов шаблон",
    "error.parent_email_must_be_filled": "Трябва да попълниш имейл на родителя",
    "label.organisation_invoicing_name": "Име на лицензанта",
    "pageTitle.related_contacts": "Свързани контакти",
    "button.try_again": "Затвори предупреждението и опитай отново",
    "label.cannot_be_change_to_another": "Не може промените към друго ниво на Наградата.",
    "notifications.lead_coordinator_has_been_set": "Зададен е нов основен Координатор",
    "label.training_name": "Име на обучението",
    "moduleTitle.new_contact": "Нов контакт",
    "translationsManagement.modal.updateTitle": "Сигурни ли сте?",
    "moduleTitle.offline_award_units_signoff": "Офлайн одобрение на Наградата от Лидер",
    "notifications.award_level_has_been_changed": "Нивото в Наградата е променено",
    "label.subject": "Относно",
    "route.silver_level": "ниво Сребро",
    "label.privacy_notice": "",
    "label.switch_organization": "Промени организация",
    "meta.dofe_name": "Международна награда на херцога на Единбург",
    "route.profile": "Профил",
    "roles.super_user": "Супер-потребител",
    "dashboard.while_you_were_gone": "Докато те нямаше",
    "label.no_note_from_award_leader": "Върнато от Националния офис на Наградата (без указания за ревизия)",
    "label.middle_name": "Бащино име",
    "moduleTitle.new_activity": "Нова дейност",
    "organisation.would_you_like_to_remove": "Искаш ли да премахнеш тази организация?",
    "label.state_province": "Регион",
    "moduleTitle.your_home_address": "Твоят домашен адрес",
    "tabs.sign_offs": "За одобрение",
    "moduleTitle.logs": "Записи",
    "button.view_more": "Виж повече",
    "label.profile": "Профил",
    "label.title": "Обръщение",
    "tabs.award_signoff": "Одобрение на Награда",
    "label.post_code": "Пощенски код",
    "states.ceremony_certificate": "Церемония и сертификат",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. Съгласен/а съм информацията, която предоставям (включително информация за участника) да бъде споделена с Оператора и Организацията/Оператор на Наградата. Съгласен/а съм тази информация да бъде използвана съгласно изискванията за лични данни на съответния Оператор на Наградата (които могат да бъдат променяни периодично), националните закони за лични данни и всички други правни наредби, стандарти, разпоредби и правилници, отнасящи се до личните данни.",
    "label.user_guide_web_participant": "Наръчник за потребители - Участник",
    "label.award_unit_type": "Вид на организацията",
    "states.complete": "",
    "table.participant_state": "Статус на участника",
    "pageTitle.my_organization_payment": "Моята организация - плащане",
    "table.approved": "Одобрено",
    "pageTitle.my_organization_contacts": "Моят организация - Контакти",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "Промени на статус <strong>{state}</strong> ?",
    "label.integer": "Integer",
    "notifications.translationUpdateInterrupted": "Актуализирането е прекъснато",
    "notifications.password_has_been_changed": "Паролата е променена",
    "button.invite_assessor": "Покани ментор",
    "label.other_activity": "Друга дейност",
    "notifications.parental_consent_has_been_sent": "Родителското съгласие е изпратено",
    "button.revise": "Върни за редакция",
    "errors.end_date_must_be_after_start_date": "Крайната дата трябва да е след началната дата.",
    "label.award_leader_signoff_date": "Дата на одобрение от Лидера на Наградата",
    "parentalConsent.i_understand_every_participant_must": "8. съм осведомен/а, че всеки участник участва в Наградата чрез Организация/Оператор, която има правото да одобрява или отхвърля участници и предложения за активности по време на Наградата.",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "Приключенско пътуване",
    "global.day": "ден",
    "moduleTitle.coordinator": "Координатор",
    "label.region": "Регион",
    "button.add_history_record": "Добави запис на историята",
    "moduleTitle.adventurous_journey_template_settings": "Настройки на шаблона за Приключенско пътуване",
    "notifications.personal_details_have_been_updated": "Личните данни са актуализирани",
    "sidebar.ics": "Независими държави (GBT)",
    "table.independent_award_centre": "Независим оператор на Наградата",
    "label.undelivered_mail_reason": "Причина за недоставяне на мейла",
    "table.utc_date_time": "Координирано универсално време",
    "moduleTitle.emails": "Имейли",
    "label.backoffice": "Backoffice",
    "moduleTitle.parent_consent": "Родителско/настойническо съгласие",
    "label.photo_consent_given": "Участникът е съгласен неговата профилна снимка да бъде използвана с рекламни цели",
    "moduleTitle.authorising_contact": "Упълномощен контакт",
    "label.assessment_with_role": "Оценка от {role}",
    "dashboard.type_of_awards": "Вид на организацията",
    "moduleTitle.payment": "Плащане",
    "states.in_progress": "В процес",
    "logs.no_logs": "Няма записи",
    "sidebar.my_office": "Моят офис",
    "label.assessor_report": "Доклад на Оценителя",
    "notifications.rp_has_been_signed_off": "Проектът в полза на общността е одобрен",
    "tabs.labels": "",
    "sidebar.payments": "Плащания",
    "meta.profile_questions": "Въпроси към профила",
    "label.fax": "Факс",
    "label.email_help_custom_link": "",
    "label.last_name": "Фамилия",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "dashboard.participant_by_level": "Участници - по нива",
    "tabs.award_leaders": "Лидери на Наградата",
    "label.i_confirm_that_ive_witnessed": "Потвърждавам, че съм видял/а книжката на участника и записите му за дейностите по-долу",
    "table.lead_coordinator": "Главен координатор",
    "states.deleted": "Изтриване",
    "label.no_answers": "Няма отговори",
    "button.add": "Добави",
    "label.exchequer_number": "Exchequer A/c No.",
    "label.waiting": "Изчакване",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "Редактирай регистрацията",
    "notifications.state_aj_preparation_training_has_been_changed": "",
    "label.parent_approval": "Родителско съгласие",
    "table.assessor_approve": "Оценителят одобрява",
    "errors.some_fields_requires_your_attention": "Някои полета изискват вашето внимание",
    "aj.qualifying_journey": "Същинско Приключенско пътуване",
    "route.awards": "Награди",
    "table.registration": "Регистрация",
    "pageTitle.assessors": "Ментори",
    "notifications.award_has_been_updated": "Наградата е актуализирана",
    "errors.must_be_one_of": "Трябва да е едно от: {enums}",
    "pageTitle.logs": "Записи",
    "notifications.notifications.invitation_has_been_sent": "Изпратена е покана",
    "route.national_offices": "Национални офиси",
    "notifications.training_has_been_updated": "Обучението е актуализирано",
    "label.parent_last_name": "Фамилия на родителя/настойника",
    "table.leaders": "Лидери",
    "states.award_level_complete": "Нивото в Наградата е завършено",
    "button.reset": "Изпращане отново",
    "sidebar.my_award_unit": "Моята организация",
    "pageTitle.all_aj_events": "Всички събития за Приключенско пътуване",
    "label.activity": "Дейност",
    "moduleTitle.are_you_sure": "Сигурен/а ли си?",
    "route.gold_level": "ниво Злато",
    "table.evidence": "Доказателство",
    "label.delivery_confirmed": "Доставката потвърдена",
    "parentalConsent.as_the_parent": "Като родител / настойник давам съгласието си Фондацията да използва за рекламни цели всички изображения.",
    "label.awardMode.offline": "Офлайн",
    "tasks.approve_registration": "Одобри регистрацията",
    "note.change_the_email_will_change": "Бележка: Смяната на имейл адрес ще промени и мигриращият имейл контакт",
    "notifications.participant_has_been_approved": "Участникът е одобрен",
    "label.reached_activity_limit": "Лимитът на дейностите е достигнат в това направление. Участниците могат да имат максимум 3 дейности във всяко направление.",
    "label.facebook": "Фейсбук",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Подготовката и инструктажите са премахнати",
    "pageTitle.settings": "Настройки",
    "participant.level_registration_date": "{value} дата на регистрация",
    "notifications.question_has_been_removed": "Въпросът е изтрит",
    "label.email_help_award_leader_full_name": "Пълните имена на Лидера.",
    "sidebar.leaders": "Лидери",
    "notifications.participants_have_been_transferred": "Участниците са прехвърлени",
    "tabs.assessors": "Ментор",
    "sidebar.dashboard": "Табло за управление",
    "pageTitle.independent_award_centers": "Независими Центрове на Наградата",
    "label.search": "Търсене",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "Бележка от участник",
    "errors.required_field": "Задължително поле",
    "tasks.approve_task": "Одобри задачата",
    "logs.edit_log": "Редактирай записа",
    "table.state": "Регион",
    "moduleTitle.level_summary": "Обобщение на нивото",
    "moduleTitle.guides": "",
    "modal.close": "Затвори",
    "label.parent_first_name": "Първо име на родителя/настойника",
    "parentalConsent.i_understand_that_the_participant": "1. Разбирам, че участникът не може да участва в Наградата, докато този формуляр не бъде завършен (включително съгласието на родителя / настойника) и върнат на съответната лицензирана организация на Награда с приложимата такса за участие, и след това приет от Лицензираната организация.",
    "tabs.award_units": "Организации",
    "table.hours": "Часове",
    "label.type": "Вид",
    "notifications.adventurous_journey_has_been_removed": "Приключенското пътуване е изтрито",
    "label.aj_is_not_approved_yet": "Приключенското пътуване не е одобрено",
    "roles.authorizing_contact": "Упълномощаващ контакт",
    "table.date_submitted_to_office_signoff": "Дата, на която наградата е изпратена за одобрение към Националния офис на Наградата",
    "notifications.section_has_been_returned": "Направлението е върнато за редакция",
    "table.created_by": "Създаден от",
    "route.user_guide_web_participant": "Наръчник за потребители - Участник",
    "route.templates": "Шаблони",
    "states.awaiting_sign_off": "Одобрение от Лидер",
    "table.phone": "Телефон",
    "label.parental_consent": "Родителско съгласие",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "ниво Бронз",
    "label.invoice_currency": "Валута на фактурата",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "Сървърът не е достъпен в момента. Моля опитайте по-късно. Ако проблемът продължава, свържете се с нашия екип по поддръжката.",
    "notifications.contact_has_been_created": "Контактът е създаден",
    "pageTitle.profile_questions": "Въпроси към профила",
    "table.observation_files": "Наблюдения - файлове",
    "table.participants": "Участници",
    "tasks.no_evidence": "Не е предоставено доказателство",
    "button.edit": "Редактирай",
    "moduleTitle.leader": "Лидер",
    "notifications.new_template_has_been_updated": "Нов шаблон е актуализиран",
    "table.name": "Име",
    "label.no_results": "Няма резултати",
    "moduleTitle.documents": "Документи",
    "button.invite": "Покани",
    "label.goal": "Цел",
    "pageTitle.nao_award_units": "Национален офис - Организации",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "Поне {length} символа",
    "label.email_help_note": "",
    "label.person_status.activating": "label.person_status.activating",
    "moduleTitle.remove_role": "Изтрий роля?",
    "label.total": "Общо",
    "label.delete_participant_award_info": "",
    "route.leaders": "Лидери",
    "table.start_date": "Начална дата",
    "moduleTitle.coordinators": "Координатори",
    "button.create": "Създай",
    "tabs.awards": "Награди",
    "parentalConsent.form_has_been_sent": "Родителското съгласие е изпратено",
    "states.journey_approval": "Одобрение на Приключенско пътуване",
    "pageTitle.reports": "Доклади",
    "table.journey_type": "Вид на Приключенското пътуване",
    "label.yes": "Да",
    "pageTitle.assessor_report": "Доклад на ментора/оценителя",
    "label.organization": "Организация",
    "notifications.award_leader_has_been_updated": "Информацията за Лидера е актуализирана",
    "moduleTitle.edit_role": "Редактирай ролята",
    "table.journey_activity": "Дейност на пътуването",
    "label.location": "Местонахождение",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "Приключенски пътувания",
    "global.assessor": "Оценител/ментор",
    "moduleTitle.profile_questions": "Въпроси за профила",
    "activity.cannot_edit_activity_if_award_in_state": "Не можете да променяте дейността, ако Награда е със статус {state}",
    "moduleTitle.assessor_detail": "Детайли за ментора",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. информиран/а съм, че при потвърждаване участието в Наградата от\nОрганизацията/Оператор участникът получава Дневник или получава достъп до Онлайн Дневника. Участникът трябва да се запознае с условията на Наградата, описани в Дневника или Онлайн Дневника преди началото на активностите, свързани с Наградата. Разбирам, че Организацията/Оператор има правото да прецени дали условията на наградата са изпълнени и дали участникът трябва да бъде награден със съответно Бронз, Сребро или Злато. Информиран/а съм, че Операторът на Наградата може да осигури на участниците частична застраховка, която да покрива злополуки и обща гражданска отговорност при приемане в наградата, но сключването на застраховка Злополука е задължение на участника и неговия родител/настойник.",
    "notifications.award_has_been_returned": "Наградата е върната за редакция",
    "label.code_of_conduct": "",
    "button.new_contact": "Нов контакт",
    "tabs.payments": "Плащания",
    "roles.naa_oa_staff": "Служители на Националния оператор",
    "label.switch_organisation_hint": "Можете да отворите този прозорец като кликнете върху \"Смени организацията\" в менюто в горния десен ъгъл",
    "label.expiration_date": "Срок на давност",
    "tabs.participants": "Участници",
    "table.practice": "Предварително",
    "notifications.one_activity_has_to_remain": "Една от дейностите в направлението трябва да остане неизтрита.",
    "label.qualifications": "Квалификации",
    "states.organization_approval": "Одобрение на организацията",
    "errors.must_be_an_integer": "Трябва да е цяло число",
    "participant.send_confirmation_email_again_question": "Изпрати отново имейл за потвърждение?",
    "button.dismiss": "Откажи",
    "table.advice": "Съвет",
    "label.years_of_working_experience": "Брой години опит в сферата",
    "notifications.search_failed": "Имаше грешка при търсенето. Моля, опитайте отново.",
    "notifications.changes_have_been_saved": "Промените са запазени",
    "moduleTitle.resend_parental_consent_link": "Изпрати отново линка за родителско съгласие?",
    "label.activity_type": "Вид на дейността",
    "label.change_award": "Промени наградата",
    "label.email": "Имейл",
    "button.remove": "Премахни",
    "button.download": "Свали",
    "label.vat_treatment": "ДДС",
    "pageTitle.aj_template_new": "Нов шаблон за Приключенско пътуване",
    "table.per_page": "за страница",
    "notifications.translations_has_been_updated": "Трансакциите са актуализирани",
    "notification.award_mode_has_been_updated": "Режимът на Наградата е актуализиран",
    "tasks.revise_item": "Редактирай елемента",
    "button.resend_parental_consent": "Изпрати отново Декларация за родителско съгласие",
    "table.weeks_completed_required": "Завършени/Изисквани седмици",
    "label.last_modified": "Последно редактиран",
    "table.major": "Основно",
    "label.vat_number": "ЕИК",
    "errors.passwords_dont_match": "Паролите не съвпадат",
    "table.country": "Държава",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "Въпросът е актуализиран",
    "table.participant_name": "Име участник",
    "label.registration_approval_date": "Дата на одобрение на регистрацията",
    "notifications.auth_code_is_no_longer_valid": "Упълномощаващият код не е валиден",
    "errors.must_be_no_more_than": "Трябва да е не повече от {max} символа",
    "notifications.event_has_been_rejected": "Събитието е върнато за редакция",
    "tabs.customizations": "Персонализиране",
    "label.name_organization": "Име",
    "button.add_log": "Добави запис",
    "moduleTitle.invite_assessor": "Покани ментор",
    "label.resend_confirmation_email": "Повторно изпращане на мейл за потвърждение",
    "text.all_participants_will_be_transfered": "Всички участници ще бъдат преместени към нов Лидер",
    "label.repeat_email": "Повторете имейла",
    "errors.email_or_phone_required": "Мейл или телефон е задължителен",
    "notifications.role_has_been_updated": "Ролята е актуализирана",
    "roles.if_staff_stat_user": "Статистически потребител на МФ",
    "participant.delete_account": "Изтрий профила",
    "moduleTitle.would_you_like_to_remove_this_log": "Искаш ли да изтриеш този запис?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "Вид на пътуването",
    "sidebar.manual_data_import": "Ръчно качване на данни",
    "label.created_after_date": "Създаден/а след",
    "route.my_organization": "Моята организация",
    "button.show_list": "Покажи списъка",
    "label.leaders": "Лидери",
    "notifications.log_has_been_modified": "Записът е променен",
    "button.upload_file": "Качи документ",
    "moduleTitle.which_section_do_you_want_to": "Кое направление искате да върнете на статус \"в процес\"",
    "tabs.bronze_level": "Бронзово ниво",
    "notifications.participants_have_been_saved": "Участниците са запазени",
    "pageTitle.aj_template_detail": "Приключенско пътуване",
    "label.parent_email": "Имейл на родителя&#39;s / Настойника&#39;s",
    "map.appr_location": "Приблизителен адрес:",
    "notifications.log_has_been_removed": "Записът е премахнат",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "Недоставени мейли",
    "button.stay": "Остани",
    "table.previous_level": "Предишно ниво",
    "label.award_start_date": "Начална дата на Наградата",
    "assessor_report.returned_to_participant": "Върнат на участника",
    "pageTitle.tasks_assessors_registration": "Регистрация на Ментор/Оценител",
    "aj.cannot_modify_award": "Не можете да промените Лидера, ако участникът няма зададен Лидер.",
    "moduleTitle.lost_internet_connection": "Изглежда, че изгубихте връзка с интернет",
    "states.ceremony": "Церемония",
    "participant.reactivate_account": "Активирай профила отново",
    "label.birthdate": "Дата на раждане",
    "pageTitle.assessment_send_successfully": "Оценката е изпратена успешно",
    "states.assessor_approval": "Одобрение от Оценител",
    "award.change_award_level": "Промени нивото в Наградата",
    "label.url_no_longer_valid": "Този линк не е валиден.",
    "button.update": "Актуализирай",
    "label.secondary_email": "Втори имейл",
    "button.role_edit": "Редактирай",
    "table.award_leader": "Лидер в Наградата",
    "label.level": "Ниво",
    "tasks.evidence": "Доказателство",
    "notifications.participant_is_already_in_list": "Участникът вече е в списъка",
    "button.clear": "Изчисти",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "Настройване",
    "table.activity": "Дейност",
    "label.copy_to_clipboard": "{text} беше копиран",
    "route.award_units": "Организации",
    "button.upload_photo": "Качи снимка",
    "table.hours_completed_required": "Завършени часове / Задължителни часове",
    "table.first_name": "Първо име",
    "notifications.adventurous_journey_has_been_returned": "Приключенското пътуване е върнато за редакция",
    "pageTitle.national_offices": "Национални офиси",
    "notifications.you_have_been_logged_in": "Влязохте в профила си",
    "logs.offline": "Офлайн",
    "moduleTitle.add_role": "Добави роля",
    "label.user_app_guide_participant": "Ръководство за потребители за приложение - Участник",
    "notifications.file_has_been_removed": "Файлът е премахнат",
    "label.send_message": "Изпрати съобщение",
    "button.select": "Избери",
    "label.reason_of_deletion": "Причина за изтриването",
    "label.user_guide": "Ръководство за потребители",
    "pageTitle.nao_participants": "Национален офис - Участници",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "Качено от",
    "tasks.approve_item": "Одобри елемента",
    "tasks.restore_participant_registration": "Възстанови регистрацията на участник?",
    "label.awardMode.hybrid": "Хибрид",
    "table.first_activity_started": "Започната е първата дейност",
    "moduleTitle.dates": "Дати",
    "table.no_results": "Няма резултати",
    "states.registration_approval": "Одобрение на регистрацията",
    "table.breakdown_of_hours": "Разбивка по часове",
    "pageTitle.tasks_registration": "Регистрация на участник",
    "button.create_new": "Създай нов",
    "sidebar.todolist": "Списък със задачи",
    "label.active_participants": "Активни участници",
    "moduleTitle.postalAddress": "moduleTitle.postalAddress",
    "tasks.return_task": "Върни задачата за редакция",
    "organisation.change_organisation_state": "Промени статуса на организацията",
    "moduleTitle.roles": "Роли",
    "label.no_config_key_available": "Не са налични ключове за конфигурация за тази секция",
    "placeholder.selectLanguage": "Избор на еизк",
    "states.office_signoff": "Одобрение от офиса на Наградата",
    "notifications.translations_has_been_updated.failure": "Неуспешно актуализиране на трансакциите",
    "logs.minute": "минута",
    "label.last_activity": "Последна дейност",
    "sidebar.user_guide": "Ръководство за потребители",
    "label.trained_award_leader": "обучен Лидер на Наградата",
    "table.progress": "Прогрес",
    "table.suboperating_authorities": "Местни координатори",
    "activity.cannot_edit_activity_offline": "Участникът работи офлайн. <br><br> Не можете да редактирате дейностите, приключенското пътуване или проекта в полза на общността, ако Наградата е в полу-офлайн режим.",
    "label.user_does_not_have_permissions": "Потребителят <strong>{user}</strong> няма право да види това съдържание.",
    "notifications.assessor_has_been_approved": "Оценителят/Менторът беше одобрен",
    "route.activity_approval": "Одобрение на дейност",
    "moduleTitle.role": "Роля",
    "button.run": "Изпълни",
    "label.to": "До",
    "notifications.file_has_been_updated": "Файлът е актуализиран",
    "moduleTitle.edit_coordinator": "Редактирай Координатора",
    "notifications.authorization_code_is_no_longer_valid": "Упълномощаващият код не е валиден",
    "button.reject": "Върни за редакция",
    "label.label.participant_status": "Статус на участника",
    "award.gold_level": "Златно ниво",
    "sidebar.variables": "Променливи",
    "parentalConsent.checkbox_copy": "Потвърждавам, че съм родител / настойник на {firstName} {lastName}. Давам съгласието си да участва в Наградата в {organizationName} под надзора на {awardLeader}. Прочетох, разбрах и съм съгласен с изискванията и условията за участие в Наградата, както е описано по-горе и на интернет страницата на оператора на наградата.",
    "button.go_to_dashboard": "Отиди в таблото за управление",
    "button.add_option": "Добави опция",
    "label.is_completed": "е завършено",
    "pageTitle.award_units": "Организации",
    "states.completed": "Завършено",
    "button.adventurous_journey_template_settings": "Настройки на шаблона за Приключенско пътуване",
    "label.system_rights": "Системни права",
    "label.assessor_assesstment_award_start_date": "Начална дата на доклада на ментора",
    "label.update_translation_question": "",
    "button.login": "Вход",
    "label.name_of_the_unit": "Име на организацията",
    "button.send": "Изпрати",
    "award.ajs": "Приключенски пътувания",
    "meta.payments_expired": "Плащания - изтекли",
    "label.age": "Възраст",
    "notifications.payment_info_updated": "Информацията за плащането е актуализирана",
    "table.is_completed": "е завършено",
    "table.invited_by": "Поканен от",
    "route.files": "Документи",
    "route.assessors": "Оценители/ментори",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "Моите участници",
    "label.change_leader_status": "Промени статуса на Лидера",
    "moduleTitle.parent_consent_form": "Формуляр за родителско/настойническо съгласие",
    "notifications.authorization_contact_has_been_set": "Зададен е упълномощен контакт",
    "button.close": "Затвори",
    "label.independent_country": "Независима държава",
    "notifications.aj_preparation_training_has_been_returned": "Подготовката и инструктажите за ПП са върнати за редакция",
    "route.history_log": "История на записите",
    "participant.account_settings": "Настройки на профила",
    "label.bulk_action_error_item": "{globalId} {firstName} {lastName} {email} защото",
    "label.orb_account": "Онлайн Дневник акаунт",
    "notifications.file_url_is_not_specified_in_configuration": "URL на файла не е конкретизиран в конфигурацията",
    "notifications.award_unit_has_been_removed": "Организацията е премахната",
    "table.parent": "Родител",
    "label.mode_of_transport": "Начин на придвижване",
    "label.parental_consent_email_info": "Не забравяйте да прегледате родителския имейл и да изпратите декларацията за родителско съгласие ръчно през екрана за детайли.",
    "label.current_award": "Текуща Награда",
    "table.action": "Действие",
    "pageTitle.suboperating_authorities": "Местни координатори",
    "notifications.award_leader_has_been_assigned": "Зададен е Лидер",
    "tabs.sign_offs_locally": "За одобрение на местно ниво",
    "Activity log has been restored": "notification.log_has_been_restored",
    "sidebar.naos": "Национални оператори на Наградата",
    "tabs.aj_templates": "Шаблони за Приключенско пътуване",
    "notifications.logging_out": "Излизане от профила...",
    "label.update_label": "",
    "button.organisation_settings": "Настройки на организацията",
    "tabs.independent_award_centers": "Независими оператори на Наградата",
    "label.current": "Текущ",
    "table.location": "Местонахождение",
    "button.search": "Търсене",
    "notifications.aj_preparation_training_has_been_approved": "Подготовката и инструктажа за Приключенско пътуване са одобрени",
    "route.participants": "Участници",
    "label.other_location_information": "Друга информация за местонахождението",
    "label.number_of_records": "Брой записи",
    "translationsManagement.infoLabel": "Тази фукнционалност позволява актуализиране на преводите от POEditor.",
    "parentalConsent.i_consent_to_pay_all": "5. давам съгласието си да заплатя всички разноски по съответните лекари, медицински сестри или болничен престой, натрупани от участника в резултат на злополука, нараняване, болест или травма, придобити от  страна на участника по време на участие или пътуване към или на връщане от Наградата, както и по време на всякакви действия или събития, свързани с Наградата.",
    "label.nationality": "Националност",
    "states.approval": "Одобрение",
    "notifications.something_went_wrong": "Нещо не е наред",
    "aj.practice": "Предварително",
    "label.addressLine2": "Адрес 2",
    "label.please_leave_a_note": "Моля, оставете бележка",
    "placeholder.select": "Избери",
    "label.observations": "Наблюдения",
    "label.aim": "Цел",
    "label.addressLine1": "Адрес",
    "roles.aj_instructor": "Инструктор за ПП",
    "meta.payments_waiting": "Плащания - изчакване",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "Инструктор",
    "moduleTitle.remove_customization_and_reset": "Премахване на настройката и нулиране на конфигурационната стойност?",
    "notifications.participant_registration_has_been_restored": "Регистрацията на участника е възстановена",
    "organisation.change_award_unit_mode": "Промени режима на организацията",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "Профилът на участник е изтрит",
    "label.language_settings": "Настройки на езика",
    "notifications.event_has_been_approved": "Събитието е одобрено",
    "label.password": "Парола",
    "label.text": "Текст",
    "table.observations": "Наблюдения",
    "notifications.participant_has_been_created": "Профилът на участник е създаден",
    "table.note_for_al": "Бележка от Лидера",
    "label.payment_confirmed": "Плащането е потвърдено",
    "label.previous_completed_award_level": "Предишно ниво (без Онлайн Дневник)",
    "pageTitle.new_aj_event": "Ново събитие за Приключенско пътуване",
    "label.backend": "Backend",
    "label.relationship_to_participant": "Взаимоотношения с участника",
    "award.physical_recreation": "Физическа активност",
    "contact.collect_emails": "",
    "moduleTitle.assessor_report_reject": "Докладът на ментора не е одобрен",
    "label.supervisor_report": "Доклад на Супервайзора",
    "table.role": "Роля",
    "route.user_guide_web_nao": "Наръчник за потребители - Фондация на Наградата",
    "label.page_not_found": "404 - Страницата не е намерена",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "Файлът е качен",
    "moduleTitle.address": "Адрес",
    "moduleTitle.lead_coordinator": "Водещ Координатор",
    "pageTitle.login": "Вход",
    "label.frontoffice": "Frontoffice",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "Проектът в полза на общността е подготвен",
    "moduleTitle.award_unit": "Организация",
    "button.remove_file": "Премахни файла",
    "moduleTitle.billing_address": "Адрес за плащане",
    "pageTitle.my_aj_events": "Моите събития за Приключенско пътуване",
    "route.tasks": "Задачи",
    "button.confirm": "Потвърди",
    "label.national_award_authority": "Национален офис на Наградата",
    "label.independent_award_centre": "Независим оператор на Наградата",
    "award.generate_award_report": "Генерирай доклад",
    "route.my_region_office_customization": "Моят регионален офис - персонализиране",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "Изпратено е запитване за смяна на паролата",
    "tabs.detail": "Детайли",
    "participant.change_participant_status": "Промени статуса на участника",
    "table.key": "Ключ",
    "label.find_address": "Намери адрес",
    "notifications.assessor_has_been_rejected": "Менторът/Оценителят е променен",
    "label.transfer_participants": "Премести участници",
    "button.continue_to_payment_gateway": "Продължи към портала за плащане",
    "notifications.participant_registration_has_been_removed": "Регистрацията на участника беше премахната",
    "moduleTitle.page_not_found": "404 - Страницата не е намерена",
    "route.adventurous_journeys": "Приключенско пътуване",
    "states.registration_assessment": "Оценка на регистрацията",
    "heading.change_award_unit_mode": "Промени режима на Наградата за тази организация",
    "label.user_guide_web_nao": "Наръчник за потребители - Фондация на Наградата",
    "tabs.silver_level": "Сребърно ниво",
    "table.paid_by": "Платено от",
    "label.your_report_has_been_successfully_sent": "Докладът ти беше изпратен успешно.",
    "sidebar.my_organization": "Моята организация",
    "pageTitle.participants": "Участници",
    "notifications.preparation_training_has_been_updated": "Подготовката и инструктажа са актуализирани",
    "moduleTitle.server_is_unreachable": "Сървърът не е достъпен",
    "label.last_activity_date": "Дата на последна активност",
    "award.bronze_level": "Бронзово ниво",
    "moduleTitle.award_units": "Организации",
    "table.completed": "Завършено",
    "moduleTitle.revise_message": "Редакция на съобщението",
    "table.lastUsed": "Последно използван",
    "award.bronze_to_gold_level": "От Бронзово до Златно ниво",
    "button.change_password": "Промени парола",
    "label.nao_price": "Цена от Националния оператор",
    "label.payment_state": "Статус на плащането",
    "label.wwc_expired": "WWC expired",
    "label.award_office_signoff_date": "Дата на одобрение от офиса на Наградата",
    "label.award_unit": "Организация",
    "award.gold_level_short": "Злато",
    "moduleTitle.other_info": "Друга информация",
    "table.note": "Бележки",
    "label.search_by_email_first_or_last": "Търсене по имейл, първо име или фамилия",
    "tabs.history": "История",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "Участници без Лидер",
    "table.main_award_leader": "Координатор",
    "parentalConsent.i_as_the_parent": "3. Аз, като родител / настойник, поемам отговорност за всички рискове, които могат да възникнат при дейностите по участие в Наградата.",
    "label.state": "Статус",
    "notifications.award_leader_has_been_removed": "Лидерът е премахнат",
    "tabs.organization_detail": "Детайли за организацията",
    "table.operating_authorities": "Регионални координатори",
    "label.available_labels": "",
    "modal.select": "Избери",
    "tabs.expired_payments": "Изтекли плащания",
    "moduleTitle.note_for_al": "Бележка от Лидера",
    "moduleTitle.confirm": "Потвърждаване",
    "notification.new_activity_added": "Добавена е нова дейност",
    "notifications.award_leader_has_been_moved": "Лидерът е преместен",
    "label.award_mode": "Режим на Наградата",
    "label.phone": "Телефон",
    "notifications.organization_has_been_updated": "Регистрацията на организацията е актуализирана",
    "moduleTitle.assessor": "Ментор",
    "label.bulk_action_confirmation": "Потвърждение на действие за групата",
    "table.parent_approval": "Одобрение от родител",
    "label.date_of_delivery": "Дата на доставка",
    "sidebar.assessors": "Ментор",
    "label.journey_activity": "Дейност на пътуването",
    "award.inactive_award": "Деактивирай наградата",
    "label.end_date": "Крайна дата",
    "label.orb_testing": "Тест на Онлайн Дневник",
    "label.no_activities": "Няма дейности",
    "moduleTitle.please_confirm": "Моля потвърди",
    "button.login_with_another_account": "Влез с друг профил",
    "tasks.reject_registration": "Редактирай регистрация",
    "label.submitted_after_date": "Подадено след",
    "label.update_translations_successful": "",
    "button.assign_leader": "Задай Лидер",
    "table.already_running": "Вече работим с Наградата",
    "label.no": "Не",
    "label.count_items_selected": "{count} избрани позиции",
    "label.secondary_phone_number": "Втори телефонен номер",
    "label.my_experience": "Моят предишен опит",
    "notifications.adventurous_journey_has_been_approved": "Приключенското пътуване е одобрено",
    "pageTitle.mro_detail": "Моят регионален офис - информация",
    "moduleTitle.nao_specific_info": "Специфична информация за Национален оператор",
    "label.preparing_document_for_import": "Подготовка на документа за качване",
    "tasks.observations": "Наблюдения",
    "notifications.confirmation_email_has_been_sent": "Изпратен е имейл за потвърждение",
    "button.restore": "Възстанови",
    "label.importing_file": "Качване на файл",
    "label.or_dont_agree": "Или не се съгласявай? Възможно е",
    "moduleTitle.award_leader": "Лидер в Наградата",
    "label.me": "(аз)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "Прехвърли таблицата",
    "organisation.move_award_unit": "Премести организацията",
    "label.file_category": "",
    "notifications.connecting_to_server": "Свързване със сървър...",
    "parentalConsent.i_understand_that_a_and_b": "11. осведомен/а съм, че: <br>\nа. на участника се забранява да управлява моторно превозно средство и да транспортира други участници по време на участието им в активности, свързани с Наградата, освен в случаите когато участникът притежава необходимата валидна шофьорска книжка и е налице подходяща застраховка от трети лица, която покрива злополуки с хора в следствие от\nдействията на участника. </br>\nб. на участника се забранява, да бъде транспортиран за участие в Наградата от лице, което не е свързано с или не подпомага Наградата, освен в случаите когато лицето притежава необходимата валидна шофьорска книжка и е налице подходяща застраховка от трети лица, която покрива злополуки с хора в следствие от действията на лицето.",
    "table.reason": "Причина",
    "pageTitle.contacts": "Контакти",
    "states.award_leader_approval": "Одобрение от Лидер",
    "meta.payments": "Плащания",
    "label.suboperating_authority": "Местен координатор",
    "route.my_region_office": "Моят регионален офис",
    "states.registration_not_approved": "Регистрацията не е одобрена",
    "label.direct_entrant": "Директен участник",
    "tabs.all_participants": "Всички участници",
    "tabs.payment": "Плащане",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "Повтори новата парола",
    "label.other_roles": "Онлайн Дневник профилна страница",
    "logs.hours": "часове",
    "notifications.spreadsheet_has_been_imported_successfully": "Таблицата беше качена успешно",
    "label.bulk_action_question": "Извършване групово действие за {count} позиции?",
    "moduleTitle.personal_details": "Лична информация",
    "label.bulk_action_emailing": "",
    "route.my_events": "Моите събития",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "Включи малки и големи букви",
    "tabs.removed_participant_registrations": "Изтрити регистрации на участници",
    "sidebar.mynao": "Моят Национален оператор на Наградата",
    "tabs.office_details": "Детайли за офиса",
    "label.major": "Основно",
    "tabs.documents": "Документи",
    "label.new_password": "Нова парола",
    "sidebar.adventure_journey": "Приключеснко пътуване",
    "pageTitle.customizations": "Персонализиране",
    "moduleTitle.assessor_report": "Доклад на {role}",
    "label.registration_date": "Дата на регистрация",
    "notifications.training_has_been_added": "Добавено е обучение",
    "aj.qualifying": "Същинско",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Излязохте от профила си, тъй като сесията ви е изтекла",
    "award.service": "Доброволчество",
    "notifications.rp_state_has_been_changed": "Проектът в полза на общността е променен",
    "label.ctest_access": "Достъп до тестовия сайт",
    "table.created": "Създадено",
    "tasks.revise_task": "Редактирай задачата",
    "button.assign": "Задай",
    "button.return": "Върни за редакция",
    "table.status": "Статус",
    "button.restore_activity": "Върни дейността",
    "tabs.new_aj_event": "Ново събитие за Приключенско пътуване",
    "roles.if_staff_viewer": "Потребител на МФ (само преглед)",
    "notifications.new_template_has_been_created": "Създаден е нов шаблон",
    "global.something_went_wrong": "Нещо не е наред",
    "table.expire_day": "Ден на изтичане",
    "tabs.history_log": "История на записите",
    "label.form_of_payment": "Начин на плащане",
    "button.add_training": "Добави инструктаж",
    "label.par_reg_cust_note": "Този прозорец ви позволява да персонализирате полетата, които се показват при регистрация на участник и ще повлияят на количеството данни, които събирате. Моля, свържете се с Регионалния офис на Наградата, ако искате да направите промени - само служителите на Международната фоднация имат достъп до тези промени.",
    "label.my_qualification": "Моята квалификация",
    "button.add_new_profile_question": "Добави нов въпрос към профила",
    "table.operating_authority": "Оператор на Наградата",
    "table.aim": "Цел",
    "table.awards": "Награди",
    "participant.deactivate_account": "Деактивирай профила",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "Първо име на Лидера.",
    "table.date": "Дата",
    "tasks.would_you_like_to_delete": "Искате ли да изтриете този участник?",
    "notifications.configuration_value_has_been_updated": "Конфигурационната стойност е актуализирана",
    "ajTemplates.fill_from_template": "Попълни от шаблон",
    "contact.send_test_email": "Изпрати тестов имейл",
    "moduleTitle.aj_preparation_and_training": "Подготовка и инструктажи за Приключеснко пътуване",
    "label.ce_be": "",
    "button.notify_participant": "Връщане към участник",
    "label.parent_phone": "Телефон на родителя&#39;s / Настойника&#39;s",
    "label.nao_regulations": "",
    "award.skills": "Умения",
    "label.reject_application": "откажи тази заявка",
    "leader.delete_account": "Изтрий профила",
    "table.assign": "Задай",
    "roles.aj_supervisor": "Супервайзор на Приключеснко пътуване",
    "label.logout": "Изход",
    "moduleTitle.award_leader_edit": "Редактира профила на лидера",
    "moduleTitle.training": "Инструктажи",
    "notifications.coordinator_has_been_removed": "Координаторът е премахнат",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "Координатор",
    "label.bulk_action_successful": "{count} позиции успешно променени.",
    "tasks.clear_email_revision": "Изчистване на поправката на мейла",
    "table.preparation": "Подготовка",
    "table.delete": "Изтрий",
    "label.safeguarding_policy": "",
    "sidebar.reports": "Доклади",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "Този участник вече е избрал основно направление в друго ниво на Наградата. Искате ли да добавите още едно?",
    "pageTitle.operating_authorities": "Регионални координатори",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "Потвърдено",
    "notifications.invitation_has_been_sent": "Изпратена е покана",
    "pageTitle.independent_countries": "Независими държави",
    "label.assessors_email": "Имейл на ментора",
    "tasks.approve_assessor_registration": "Одобряване на регистрацията на Ментора/Супервайзора",
    "table.award_duration": "Продължителност на Наградата",
    "notifications.organization_has_been_moved": "Организацията беше премахната",
    "pageTitle.nao_payment": "Национален офис - Плащане",
    "participant.history_log": "История на записите",
    "label.rejected_with_note": "",
    "label.already_running": "Вече работи с Наградата",
    "button.continue": "Продължи",
    "award.no_data_to_show": "Няма данни за показване",
    "participant.send_email_invitation_again_question": "Изпрати покана по имейл отново?",
    "label.reason_for_changing_assessor": "Причина за смяна на Ментора",
    "button.delete": "Изтрий",
    "moduleTitle.requirements_and_conditions": "Изисквания и условия",
    "roles.leader": "Лидер",
    "label.if_download_doesnt": "Ако изтеглянето не започне автоматично, моля проверете настройките за поп-ъп на вашия браузър",
    "dashboard.your_todo_list": "Твоят списък със задачи",
    "notifications.award_unit_has_been_returned": "Регистрацията на организацията е върната за редакция",
    "moduleTitle.participant_activities": "Дейности на участника",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "Активни Лидери",
    "aj.preparation": "Подготовка",
    "button.change_state": "Промени статус",
    "label.current_password": "Сегашна парола",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "Настройки на контакт",
    "button.remove_photo": "Изтрий снимката",
    "notifications.activity_has_been_setup": "Дейността е подготвена",
    "errors.must_be_more_than": "Трябва да е повече от {limit}",
    "table.goal": "Цел",
    "notifications.coordinator_has_been_set": "Зададен е координатор",
    "label.cc": "Копие",
    "label.duration": "Продължителност",
    "table.actions": "Действия",
    "participant.send_email_invitation_again": "Изпрати покана по имейл още веднъж?",
    "moduleTitle.would_you_like_to_remove_participant": "Искате ли да изтриете участник #{value}",
    "parentalConsent.i_authorise_employees": "4. Упълномощавам служители или представители на Лицензирания оператор на Наградата и всички други лица, които участват или съдействат за организирането на наградата в случай на катастрофа, нараняване, заболяване или загуба, претърпени от участника, докато участва или да пътувате до и от всякакви дейности или функции, свързани с Наградата, да получи необходимата медицинска помощ или лечение, включително, но без да се ограничава до ангажиране на лекари, медицински сестри или болнични заведения.",
    "button.reload_page": "Зареди страницата наново",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "Имейл",
    "label.new_goal": "Нова цел",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "Невалиден имейл адрес",
    "pageTitle.new_contact": "Нов контакт",
    "sidebar.gops": "",
    "button.manage_participants": "Управление на участници",
    "errors.invalid_phone_format": "Невалиден телефонен номер",
    "notifications.login_details_have_been_changed": "Детайлите за вход бяха променени",
    "moduleTitle.participant_logs": "Записи на участника",
    "label.save": "Запази",
    "label.frequently_asked_questions": "Често задавани въпроси (ЧЗВ)",
    "label.city": "Град",
    "notifications.configuration_value_has_been_reset": "Стойността на конфигурацията е нулирана",
    "states.office_sign_off": "Одобрение от офиса на Наградата",
    "button.save": "Запази",
    "button.import_data_from_selected_file": "Качване на данни от избран файл",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. Информиран/а съм, че участникът не може да започне етап от Наградата докато аз не се убедя, че доброволците, избрани от участника и които не са служители от Организацията/Оператор на Наградата са достатъчно квалифицирани и/или имат достатъчно опит да инструктират/ръководят/оценяват това направление от Наградата; и докато съответните оброволци не попълнят и изпратят до Организацията/Оператор всички необходими документи.",
    "pageTitle.apiKeys": "API ключове",
    "label.international_region": "Вътрешен регион",
    "tabs.levels": "Нива",
    "tabs.additional_files": "Допълнителни документи",
    "label.continuation_level": "Продължение на ниво",
    "table.adventurous_journey_detail": "Детайли за Приключенско пътуване",
    "button.set": "Задай",
    "label.i_certify_that_as_the_assessor": "Потвърждавам, че като {role} на тази дейност, участникът е изпълнил изискванията.",
    "table.coordinator": "Координатор",
    "participant.send_confirmation_email_again": "Изпрати отново имейл за потвърждение?",
    "table.report": "Доклад",
    "label.update_translations_results": "",
    "table.observation_note": "Бележка за наблюденията",
    "label.view_more": "Виж повече",
    "notifications.payment_link_has_been_reset": "Линкът за плащане е изпратен отново",
    "table.type": "Вид",
    "moduleTitle.updateConfigurationKey": "Ключ за конфигурационна стойност",
    "sidebar.independent_award_centers": "Независими Центрове на Наградата",
    "table.activity_type": "Вид дейност",
    "label.awardMode.online": "Онлайн",
    "table.data_state": "Последно актуализиране на данните",
    "button.generate_report": "Генерирай доклад",
    "moduleTitle.assessed_by_award_leader": "Оценено от Лидера",
    "table.child_protection_number": "Номер на политиката за закрила на детето",
    "button.bulk_change": "Промяна на група",
    "label.send_welcome_email": "",
    "label.award_state": "Прогрес на Наградата",
    "moduleTitle.overview": "Общ преглед",
    "table.aj_detail": "Информация за Приключенско пътуване",
    "pageTitle.tasks_activity_approvals": "Одобрение на дейности",
    "label.section": "Направление",
    "route.history": "История",
    "route.event_participants": "Участници в събитието",
    "participant.account_detail": "Настройки на профила",
    "route.dashboard": "Табло за управление",
    "table.payments": "Плащания",
    "pageTitle.profile": "Профил",
    "organisation.remove_organisation": "Премахни организацията",
    "pageTitle.my_organization": "Моята организация",
    "label.award_leader": "Лидер",
    "notifications.assessor_has_been_updated": "Менторът/Оценителят е актуализиран",
    "label.participant_personal_reflection": "",
    "button.add_key": "Добави ключ",
    "header.appMotto": "DUKE",
    "table.qualifying": "Същинско",
    "button.upload": "Качване",
    "button.resend": "Изпрати отново",
    "label.filename": "Име на файла",
    "label.change_parental_consent": "",
    "button.cancel": "Отказ",
    "label.aply_to_all_langs": "Приложи за всички езици",
    "route.customization": "Персонализиране",
    "errors.minimal_duration_is": "Минималната продължителност е 30 мин.",
    "label.email_help_participant_first_name": "Първо име на участника.",
    "label.participant_status": "Статус на участника",
    "award.bronze_level_short": "Бронз",
    "label.phone_type": "Вид на телефона",
    "global.night": "нощ",
    "button.adventurous_journey_settings": "Настройки на Приключенското пътуване",
    "participant.leader_must_be_selected": "Трябва да изберете Лидер",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "Потребителят добави Подготовка и инструктажи",
    "table.approve": "Одобри",
    "label.role_in_organisation": "Роля в организацията",
    "states.finished": "Приключено",
    "label.created": "Създаден",
    "button.back_to_home": "Обратно в началната страница",
    "label.options": "Опции",
    "contact.next_level_invitation": "Покана за следващото ниво",
    "moduleTitle.activity_detail": "Детайли за дейността",
    "route.section_signoff": "Одобряване на направление",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "Настройки на контакта",
    "label.transation_id": "Номер на транзакцията",
    "notifications.activity_has_been_updated": "Дейността е актуализирана",
    "sidebar.awards": "Награди",
    "parentalConsent.images_consent": "Като родител / настойник давам съгласието си Фондацията да използва за рекламни цели всички изображения.",
    "participant.would_you_like_to_delete": "Искате ли да изтриете този профил?",
    "roles.user": "Потребител",
    "label.label": "",
    "label.select_sheet": "",
    "global.no_results": "Няма резултати",
    "moduleTitle.address_line_2": "Адрес 2",
    "states.awaiting_office_sign_off": "Изчакване на одобрение от офиса на Наградата",
    "moduleTitle.export": "Прехвърли",
    "moduleTitle.address_line_1": "Адрес 1",
    "notifications.participant_has_been_assigned": "Зададен е участник",
    "roles.viewer": "Наблюдател",
    "label.participants_total": "Общо участници",
    "errors.auth_code_is_no_longer_valid": "Кодът за упълномощаване не е валиден - вече сте го използвал/а или е изтекъл",
    "label.file_is_not_available": "Файлът не е достъпен",
    "button.select_template": "Избери шаблон",
    "label.payment": "Плащане",
    "award.silver_level_short": "Сребро",
    "table.participant_id": "Участник №",
    "text.hours_old": "{hours} часа",
    "moduleTitle.your_personal_information": "Твоята лична информация",
    "aj.minimum_date_recommendation": "Минимална препоръчителна дата за Приключенско пътуване и {name} е",
    "label.date_of_payment": "Дата на плащане",
    "button.view": "Преглед",
    "label.create_new_label": "",
    "title.confirmation": "Потвърждение",
    "button.set_participants": "Настройте участници",
    "roles.assessor": "Оценител",
    "moduleTitle.coordinator_settings": "Настройки на Координатора",
    "label.parent_relationship": "Взаимоотношения с родител&#39;s",
    "table.nao": "Национален оператор на Наградата",
    "notifications.email_has_been_sent": "Имейлът е изпратен",
    "label.email_help_participant_full_name": "Пълните имена на участника.",
    "sidebar.suboperating_authorities": "Местни координатори",
    "route.award": "Награда",
    "label.no_roles": "Няма роли",
    "table.files": "Файлове",
    "aj.minimum_date_requirements": "Минималното изискване за дата за същинско Приключенско пътуване и {name} е",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "Участникът е офлайн",
    "moduleTitle.other_coordinators": "Други Координатори",
    "button.updateSelectedLanguage": "Избор на еизк",
    "tasks.approve_award_registration": "Одобри регистрация",
    "participant.invite_participant_to_next_level": "Покани участника за следващо ниво?",
    "label.twitter": "Туитър",
    "pageTitle.awards": "Награди",
    "warning.award_marked_as_paid": "",
    "table.edit": "Редактирай",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "Международна наградата",
    "moduleTitle.after_assigning_a_role_to_yourself": "След като зададете или смените ролята си, ще бъде необходимо да влезете в профила си отново.",
    "label.transaction_id": "ID на транзакцията",
    "table.suboperating_authority": "Подоператор на Наградата",
    "label.participant_survey": "Като участник в Наградата с удоволствие ще се включа в проучванията на Международната фондация",
    "label.created_by": "Създаден от",
    "button.send_confirmation_email_again_question": "Изпрати имейлът за потвърждение отново",
    "label.email_help_award_leader_email": "Имейл на Лидера.",
    "label.name": "Име",
    "tabs.gold_level": "Златно ниво",
    "pageTitle.award_documents": "Документация на Наградата",
    "label.online_payments": "Онлайн плащания",
    "label.child_protection_number": "Номер на политиката за закрила на детето",
    "participant.send_password_recovery_email": "Изпрати имейл за възстановяване на паролата?",
    "notifications.new_log_has_been_added": "Добавен е нов запис",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Име на организацията",
    "pageTitle.my_organization_templates": "Моята организация - Шаблони",
    "pageTitle.award_leaders": "Лидери на Наградата",
    "label.status": "Статус",
    "label.street": "Улица",
    "roles.if_staff_superuser": "Суперпотребител на МФ",
    "table.licence_holder": "Упълномощен",
    "label.created_at": "Създаден на",
    "table.section": "Направление",
    "table.system_rights": "Системни права",
    "label.iac_type": "Вид на организацията",
    "label.other": "Друго",
    "moduleTitle.login": "Вход",
    "label.no_data_to_show": "Няма данни за показване",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Не можете да промените нивото на Нагадата на участник, който е записан за Приключенско пътуване.",
    "tabs.waiting_payments": "Изчакващи плащания",
    "global.supervisor": "Супервайзор",
    "notifications.new_role_has_been_added": "Добавена е нова роля",
    "award.silver_level": "Сребърно ниво",
    "heading.change_awards_mode": "Промени режима на Наградата",
    "button.save_changes": "Запази промените",
    "organisation.would_you_like_to_move_award_unit": "Къде бихте искали да изтриете тази организация?",
    "label.fields": "",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "Моят регионален офис - Детайли",
    "table.started_at": "Започнато на",
    "parentalConsent.i_consent_to_the_award_unit": "2. Съгласявам се Лицеинзирания оператор на Наградата и всички други лица, включително доброволци*, които участват или съдействат за организирането на Наградата и наети шофьори, превозващи участника с цел участие в дейности или функции, свързани с Наградата, както се изисква. Разбирам, че Лицеинзирания оператор на Наградата ще ме уведоми предварително кога и къде ще се случи такова пътуване.",
    "logs.minutes": "минути",
    "label.total_participants": "Всички участници",
    "moduleTitle.contact_info": "Контактна информация",
    "table.payment_link": "Линк за плащане",
    "errors.please_contact_your_local_award_staff": "Моля, свържете се с Националния координатор."
}